import gql from 'graphql-tag';

interface GetFieldsByOperationVariables {
  operationId: string;
  partialNameSearch?: string;
  sortBy?: string;
  sortDirection?: string;
}

export const getFieldsByOperationQuery = (variables: GetFieldsByOperationVariables) => ({
  variables,
  query: gql`
    query getFieldsByOperation(
      $operationId: ID!
      $partialNameSearch: String
      $sortBy: FieldsSortBy
      $sortDirection: SortDirection
    ) {
      withOperationFields(
        operationId: $operationId
        fieldsSearchControl: {
          partialNameSearch: $partialNameSearch
          sortBy: $sortBy
          sortDirection: $sortDirection
        }
      ) {
        harvestStats {
          fields {
            id
            name
          }
        }
      }
    }
  `,
});
